var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerSegment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.13,
    height: 22,
    viewBox: "0 0 28.13 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42351",
    "data-name": "Path 42351",
    d: "M7.587,74.431a2.162,2.162,0,0,0,3.056,0L21.1,63.97a3.063,3.063,0,0,0,.682-1.04,11,11,0,0,0,2.975.445c2.23-.012,2.969-.988,3.212-1.571s.416-1.791-1.15-3.385l-.052-.052a12.506,12.506,0,0,0-3.98-2.53c-.295-.121-.589-.231-.878-.335v-.017a2.365,2.365,0,0,0-2.334-2.334l-6.267-.087a3.048,3.048,0,0,0-2.212.9L.633,64.426a2.162,2.162,0,0,0,0,3.056Zm8.064-17.624a1.787,1.787,0,0,1,3.033,1.525,12.469,12.469,0,0,0,2.386,1.3c.312.127.612.243.9.341l-.035-2.519c.052.023.1.04.15.064a10.888,10.888,0,0,1,3.391,2.137l.035.035c.751.768.832,1.259.768,1.409-.2.468-2.3.884-5.5-.451a12.354,12.354,0,0,1-2.524-1.4c-.023.029-.052.058-.075.087a1.785,1.785,0,1,1-2.524-2.524Z",
    transform: "translate(0 -53.064)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerSegment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_player_segment.21303f44e4556ac1f3b1fe67b087ec72.svg";